import React from 'react';
import Header from '../component/header';
import BannerImg from '../image/shop.png';
import Banner from '../component/Banner';
import Footer from '../component/Footer';
import FeaturedProduct from '../component/shop/FeaturedProduct';
import Spotlight from '../component/Spotlight';
import Why from '../component/shop/Why';

const Shop = () => {
  return (
    <>
    <Header />
          <Banner
            backgroundImage={BannerImg}
            heading="The Lightweave Shop"
            paragraph="The Lightweave Shop extends the mission of Lightweave Beacon Legacy beyond the gallery walls. Every purchase directly supports grants, challenges, and educational opportunities for artists around the world. From limited-edition art prints to foundation merchandise and partner offerings, each item carries purpose, craftsmanship, and creative impact."
            minHeight="100vh"
            padding="80px 0"
            bton="Members please sign-in"
          />
          <FeaturedProduct/>
          <Why/>
          <Spotlight/>
          <Footer />
    
    </>
  )
}

export default Shop
